import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import Login from './pages/Login';
import Editor from './pages/Editor';
import SettingsLayout from './pages/settings/SettingsLayout';
import WizardPage from './pages/WizardPage';
import FormsPage from './pages/FormsPage';
import FormEditorPage from './pages/FormEditorPage';
import MediaPage from './pages/MediaPage';
import DashboardPage from './pages/DashboardPage';
import Shell from './components/Shell';
import { api, ApiException } from './api/client';
function RedirectToSubmissionsTab() {
    const { id } = useParams();
    return _jsx(Navigate, { to: `/forms/${encodeURIComponent(id ?? '')}/edit?tab=submissions`, replace: true });
}
export default function App() {
    const [auth, setAuth] = useState({ status: 'loading' });
    const navigate = useNavigate();
    async function bootstrap() {
        try {
            const [{ user }, { site }, { brand }] = await Promise.all([api.me(), api.config(), api.brand()]);
            setAuth({ status: 'signed-in', user, config: site, brand });
        }
        catch (err) {
            if (err instanceof ApiException && err.status === 401) {
                setAuth({ status: 'anon' });
            }
            else {
                setAuth({ status: 'anon' });
                console.error(err);
            }
        }
    }
    useEffect(() => { bootstrap(); }, []);
    async function handleSignedIn(_user) {
        await bootstrap();
        navigate('/', { replace: true });
    }
    async function handleSignOut() {
        try {
            await api.logout();
        }
        catch { /* noop */ }
        setAuth({ status: 'anon' });
        navigate('/login', { replace: true });
    }
    if (auth.status === 'loading') {
        return _jsx("div", { className: "shell", children: _jsx("div", { className: "card", children: "Loading\u2026" }) });
    }
    if (auth.status === 'anon') {
        return (_jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(Login, { onSignedIn: handleSignedIn }) }), _jsx(Route, { path: "/*", element: _jsx(Navigate, { to: "/login", replace: true }) })] }));
    }
    const isOwner = auth.user.role === 'owner';
    return (_jsx(Shell, { user: auth.user, brand: auth.brand, onSignOut: handleSignOut, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(DashboardPage, {}) }), _jsx(Route, { path: "/login", element: _jsx(Navigate, { to: "/", replace: true }) }), _jsx(Route, { path: "/pages", element: _jsx(Editor, { config: auth.config, brand: auth.brand }) }), _jsx(Route, { path: "/pages/:slug", element: _jsx(Editor, { config: auth.config, brand: auth.brand }) }), _jsx(Route, { path: "/wizard", element: _jsx(WizardPage, {}) }), _jsx(Route, { path: "/forms", element: _jsx(FormsPage, {}) }), _jsx(Route, { path: "/forms/:id/edit", element: _jsx(FormEditorPage, {}) }), _jsx(Route, { path: "/forms/:id/submissions", element: _jsx(RedirectToSubmissionsTab, {}) }), _jsx(Route, { path: "/media", element: _jsx(MediaPage, {}) }), _jsx(Route, { path: "/brand", element: _jsx(Navigate, { to: "/settings?tab=brand", replace: true }) }), _jsx(Route, { path: "/libraries", element: _jsx(Navigate, { to: "/settings?tab=libraries", replace: true }) }), isOwner && _jsx(Route, { path: "/users", element: _jsx(Navigate, { to: "/settings?tab=users", replace: true }) }), isOwner && _jsx(Route, { path: "/settings", element: _jsx(SettingsLayout, { me: auth.user, site: auth.config }) }), _jsx(Route, { path: "/*", element: _jsx(Navigate, { to: "/", replace: true }) })] }) }));
}
